import { Component } from '@angular/core';

export enum ColorSchemePreference {
	LIGHT = 'light',
	DARK = 'dark',
	AUTO = 'auto',
}

interface ColorSchemeState {
	available : boolean;
	preference : ColorSchemePreference;
	cookie : string;
}

const DARK_QUERY = '(prefers-color-scheme: dark)';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

@Component({
	selector    : 'menu-color-scheme-toggle',
	templateUrl : './color-scheme-toggle.component.html',
	styleUrls   : ['./color-scheme-toggle.component.scss']
})
export class ColorSchemeToggleComponent {

	public readonly options = [
		{value : ColorSchemePreference.LIGHT, label : 'Light'},
		{value : ColorSchemePreference.DARK, label : 'Dark'},
		{value : ColorSchemePreference.AUTO, label : 'Device default'},
	];

	public state : ColorSchemeState | undefined = window['ngColorScheme'];

	public get isNds3Page() : boolean
	{
		return document.body.classList.contains('nds3-layout');
	}

	public select(preference : ColorSchemePreference) : void
	{
		if (!this.state || this.state.preference === preference) return;

		this.state.preference = preference;
		const os_scheme = window.matchMedia?.(DARK_QUERY).matches ? ColorSchemePreference.DARK : ColorSchemePreference.LIGHT;

		const root = document.documentElement;
		root.setAttribute('data-theme-pref', preference);
		root.setAttribute('data-theme', preference === ColorSchemePreference.AUTO ? os_scheme : preference);

		// Host-wide (path=/) so every setup on this host and the login page share the choice.
		const secure = location.protocol === 'https:' ? '; Secure' : '';
		document.cookie = `${this.state.cookie}=${preference}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax${secure}`;
	}
}
